module.exports = __webpack_public_path__ + "static/img/smile_face.e1302d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/activity/november/smile_face.png
// module id = I2hp
// module chunks = 86